import React, {
  createContext, useState, useContext,
} from 'react';
import PropTypes from 'prop-types';

const DESKTOP_BREAKPOINT = 768;

const SidebarContext = createContext();

export function SidebarProvider({ children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    () => window.innerWidth >= DESKTOP_BREAKPOINT,
  );

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <SidebarContext.Provider value={{ isSidebarOpen, toggleSidebar, closeSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
}

SidebarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useSidebar() {
  return useContext(SidebarContext);
}
